// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Production24CircleFilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Production24CircleFilled: FC<Production24CircleFilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="32"
            height="32"
        >
            <path d="M19.98 16c0 2.21-1.782 4-3.98 4s-3.98-1.79-3.98-4 1.782-4 3.98-4 3.98 1.79 3.98 4Z" />
            <path
                d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Zm-3.097-8.903a.541.541 0 0 0-.312-.415 3.675 3.675 0 0 1-.335-.182 8.173 8.173 0 0 1-.328-.212.518.518 0 0 0-.492-.053l-2.293.968a.5.5 0 0 1-.627-.211L6.22 19.006a.5.5 0 0 1 .13-.647l1.979-1.506a.568.568 0 0 0 .209-.47V15.617a.568.568 0 0 0-.21-.47L6.35 13.641a.5.5 0 0 1-.13-.647l2.296-3.986a.5.5 0 0 1 .627-.211l2.293.968a.523.523 0 0 0 .493-.052c.11-.074.223-.145.34-.213.11-.065.222-.125.333-.18.16-.08.277-.23.3-.408l.307-2.474A.5.5 0 0 1 13.705 6h4.59a.5.5 0 0 1 .496.438l.306 2.465a.541.541 0 0 0 .312.415c.116.056.227.116.335.182.11.068.22.138.328.212.145.099.33.121.492.053l2.293-.968a.5.5 0 0 1 .627.211l2.296 3.986a.5.5 0 0 1-.13.647l-1.979 1.506a.568.568 0 0 0-.209.47V16.337c0 .206.059.42.222.544l1.941 1.478a.5.5 0 0 1 .13.647l-2.295 3.985a.5.5 0 0 1-.629.21l-2.266-.965a.523.523 0 0 0-.495.052c-.11.073-.223.144-.339.212a5.307 5.307 0 0 1-.333.18.533.533 0 0 0-.3.408l-.307 2.474a.5.5 0 0 1-.496.438h-4.59a.5.5 0 0 1-.496-.438l-.306-2.465Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Production24CircleFilled;
